import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setShipping, selectShipping } from '../../slice/itemSlice';
import { Col, Row, Form } from 'react-bootstrap'

const Shipping = () => {

  const dispatch = useDispatch();
  const method = useSelector(selectShipping)
  const allMethods = [{name:'free', price: 0}, {name:'standard', price: 1}, {name:"express", price: 3}];
  
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState(undefined);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("The info to use for shipping: ", country, city, street, number, name, phoneNumber)
  }

  return (<>
    <Row className='bg-light p-2'>
      <Col className='' lg={5} md={12}>
        <h2 className='display-6 text-dark-50'>Shipping Method</h2>

          {allMethods.map(m => <div key={m.name} className="form-check mt-4 mx-3 fs-5">
            <input 
              onChange={(e) => dispatch(setShipping(e.target.value))} 
              className="form-check-input" 
              type="radio" 
              name="shippment-radios" 
              id={`radio-${m.name}`} 
              value={m.name}
              checked={m.name === method}
              />
            <label className="form-check-label text-capitalize text-info" htmlFor={`radio-${m.name}`}>
              {m.name} <span className='text-dark'>{m.price} $</span>
            </label>
          </div>)}
      </Col>
      <Col className='mt-md-4 mt-lg-0' lg={7} md={12}>
        <h2 className='display-6 text-dark-50'>Shipping Adress</h2>
        <Form onSubmit={(e) => handleSubmit(e)}>

          <Form.Group className="mb-3" controlId="formFullName">
            <Form.Label>Name and Surname</Form.Label>
            <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setName(e.target.value)} required type="name" placeholder="Enter Name" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPhoneNumber">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setPhoneNumber(e.target.value)} type="tel" name="phone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" placeholder="" />
            <Form.Text className="text-muted">
              For shipping details
            </Form.Text>
          </Form.Group>
          <Row>
            <Col>
            <Form.Group className="mb-3" controlId="formCountry">
              <Form.Label>Country</Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setCountry(e.target.value)} required type="text" placeholder="" />
            </Form.Group>
            </Col>
            <Col>
            <Form.Group className="mb-3" controlId="formCity">
              <Form.Label>City</Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setCity(e.target.value)} required type="text" placeholder="" />
            </Form.Group>
            </Col>
        
          </Row>
          <Row>
            <Col>
            <Form.Group className="mb-3" controlId="formStreet">
              <Form.Label>Street</Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setStreet(e.target.value)} required type="text" placeholder="" />
            </Form.Group>
            </Col>
            <Col>
            <Form.Group className="mb-3" controlId="formNumber">
              <Form.Label>Door / Floor Number</Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setNumber(e.target.value)} required type="text" placeholder="" />
            </Form.Group>
            </Col>
        
          </Row>
        </Form>
      </Col>
    </Row>
  </>)
}

export default Shipping